import { render, staticRenderFns } from "./academicSite.vue?vue&type=template&id=019d183f"
import script from "./academicSite.vue?vue&type=script&lang=js"
export * from "./academicSite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports